import PropTypes from "prop-types"

export const collections = PropTypes.oneOf(["documentation", "api-reference"])

export const sidebarDataNodeShape = PropTypes.shape({
  title: PropTypes.string.isRequired,
  link: PropTypes.string,
  items: PropTypes.arrayOf(
    () =>
      (...args) =>
        sidebarDataNodeShape.apply(this, args)
  )
})

export const gatsbyImageDataShape = PropTypes.shape({
  layout: PropTypes.oneOf(["fluid", "fixed", "constrained"]),
  height: PropTypes.number,
  width: PropTypes.number,
  images: PropTypes.shape({
    sources: PropTypes.arrayOf(
      PropTypes.shape({
        srcSet: PropTypes.string
      })
    ),
    fallback: PropTypes.shape({
      src: PropTypes.string,
      srcSet: PropTypes.string,
      sizes: PropTypes.string
    })
  }),
  placeholder: PropTypes.shape({
    fallback: PropTypes.string
  })
})

export const searchResult = {
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  highlightedTitle: PropTypes.string,
  articlePlainText: PropTypes.string
}

const tocItemShape = {
  url: PropTypes.string,
  title: PropTypes.string
}

tocItemShape.children = PropTypes.arrayOf(PropTypes.shape(tocItemShape))

export const tableOfContentsShape = PropTypes.shape({
  items: PropTypes.arrayOf(PropTypes.shape(tocItemShape))
})
